import { observer } from 'mobx-react-lite';
import modalStore from '../../stores/modalStore';
import { logClientEvent } from '../../hooks/useAnalytics';
import { twMerge } from 'tailwind-merge';

export const GuideButton = observer(
    ({
        docKey,
        className,
        children,
    }: {
        docKey: string;
        className?: string;
        children: React.ReactNode;
    }) => {
        return (
            <button
                className={twMerge('btn', className)}
                onClick={async (e) => {
                    e.preventDefault();

                    await modalStore.guide({ docKey });

                    logClientEvent('guide', {
                        doc_key: docKey,
                    });
                }}
            >
                {children}
            </button>
        );
    },
);

/**
 * 안내 버튼
 */
export const GuideIconButton = observer(
    ({ docKey, className }: { docKey: string; className?: string }) => {
        return (
            <GuideButton
                docKey={docKey}
                className={twMerge(
                    'btn btn-xs btn-circle text-base-content/50 hover:text-base-content/70 flex size-5 items-center justify-center border-none shadow-none',
                    className,
                )}
            >
                ?
            </GuideButton>
        );
    },
);
